import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { AccountSetupApiService } from './account-setup-api.service';

@NgModule({
  imports: [I18nModule],
  providers: [AccountSetupApiService],
  exports: [I18nModule],
})
export class AccountSetupSharedModule {}
